import React, { useEffect, useState, useContext } from "react";
import {
  Modal,
  TimePicker,
  DatePicker,
  Select,
  Badge,
  Spin,
  Popconfirm,
  Table,
  Progress,notification
} from "antd";
import ReactApexChart from "react-apexcharts";

import { PlusCircle, Upload } from "react-feather";
import { Link, useLocation } from "react-router-dom";
import dayjs from "dayjs";
// import ReactApexChart from "react-apexcharts";
import {
  createAttendanceMethod,
  deleteAdminAttendance,
  // getAllEmployeesWithoutPaginationMethod,
  // getAllShiftsMethod,
  //getAllAdmintAttendancesWithoutPagination
} from "../../service/ApiServices";
import BulkUploadModal from "../../core/modals/hrm/bulkupload-admin.jsx";
import { API_BASE_URL } from "../../../src/environment";
import { Input } from "antd";
//pdf generte import start
import jsPDF from "jspdf";
//import html2canvas from 'html2canvas';
//import jsPDF from 'jspdf';
import "jspdf-autotable";
//pdf generte import end
//import * as XLSX from 'xlsx';
import ExcelJS from "exceljs";
const { RangePicker } = DatePicker;
//const {RangePicker} = TimePicker;
import okilogo from "../../assets/OKI-logo.png";
import EditAttendanceAdminModal from "../../core/modals/hrm/editAttendanceNew.jsx";
import axios from "axios";
import moment from "moment";
import { getAllDepartments as allDepartments } from "../../service/departmentService";
import {
  // Clock,
  // Users,
  // ChevronLeft,
  // ChevronRight,
  Calendar,
} from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import { getAllEmployeesMethod } from "../../service/ApiServices";
const Designation = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const dashboardState = location.state;
  
  const startOfCurrentMonth = dayjs().startOf("month");
  const endOfCurrentMonth = dayjs().endOf("month");
  const [selectedRange] = useState([startOfCurrentMonth, endOfCurrentMonth]);
  // const [timeRangeForFetch, setTimeRangeForFetch] = useState(null);
  // const [hours] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  // const [minutes] = useState(null);
  const [workingHours, setWorkingHours] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  //const [timeRange, setTimeRange] = useState(null);
  const [date, setDate] = useState(null);
  const [employee, setEmployee] = useState(null);
  // const [shift, setShift] = useState(null)
  const [search] = useState("");
  const [employees, setEmployees] = useState([]);
  //const [shifts, setShifts] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2] = useState(false);
  //const [loading3, setLoading3] = useState(false)
  const [success, setSuccess] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [shouldReloadData, setShouldReloadData] = useState(false);
  const [id, setId] = useState("");
  const [recordDate, setRecordDate] = useState(null);
  const [recordEmpId, setRecordEmpId] = useState(null);
  const [employeeId, setEmployeeId] = useState("");
  const [branchId, setBranchId] = useState(
    dashboardState?.fromDashboard && dashboardState?.branch
      ? dashboardState.branch
      : ""
  );
  const [progress, setProgress] = useState(0);
  const [time, setTime] = useState(null);
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [
  //   // currentTime,
  //   setCurrentTime] = useState("");
  // const [selectedDates, setSelectedDates] = useState([]);
  const [empType, setEmpType] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const pageSizeOptions = [5, 10, 20, 50, 100];
  // const [currentDate, setCurrentDate] = useState(new Date());
  const [employeeName, setEmployeeName] = useState("");
  // const [attendanceWeeklyChart, setAttendanceWeeklyChart] = useState({
  //   series: [],
  //   options: {}
  // });
  const [startDate, setStartDate] = useState(
    dashboardState?.fromDashboard && dashboardState?.startDate
      ? dashboardState.startDate
      : moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dashboardState?.fromDashboard && dashboardState?.endDate
      ? dashboardState.endDate
      : moment().endOf("month").format("YYYY-MM-DD")
  );

  const [attendanceData, setAttendanceData] = useState({
    data: [],
    page: 1,
    limit: 10,
    total: 0,
  });
  const [pdfData, setPdfData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const employeeTypes = [
    { value: "", label: "Choose" },
    { value: "Academic", label: "Academic" },
    { value: "Non Academic", label: "Non Academic" },
  ];
    const [api, contextHolder] = notification.useNotification();
  
    const showNotification = (type, message, description) => {
      api[type]({
        message,
        description,
        placement: 'topRight',
        duration: 4.5,
      });
    };
  // const updateCurrentTime = () => {
  //   const current = new Date();
  //   const hours = current.getHours().toString().padStart(2, "0");
  //   const minutes = current.getMinutes().toString().padStart(2, "0");
  //   const seconds = current.getSeconds().toString().padStart(2, "0");
  //   setCurrentTime(`${hours}:${minutes}:${seconds}`);
  // };
  const handleReloadData = () => {
    setShouldReloadData(!shouldReloadData);
  };
  //Function generate to excel
  const handleTimeChange = (time) => {
    const formatTime = time ? time.format("HH:mm:ss") : null;
    setTime(formatTime);
  };
  const handleReasonChange = (e) => {
    setReason(e.target.value); // Update state with the new value
    console.log("Reason:", e.target.value); // Optional: Log the updated value
  };

  const showWarning = (str) => {
   showNotification('error', 'Error', str);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };
  // const handlePreviousMonth = () => {
  //   const newDate = new Date(currentDate);
  //   newDate.setMonth(newDate.getMonth() - 1);
  //   setCurrentDate(newDate);
  // };

  // // Function to navigate to the next month
  // const handleNextMonth = () => {
  //   const newDate = new Date(currentDate);
  //   newDate.setMonth(newDate.getMonth() + 1);
  //   setCurrentDate(newDate);
  // };

  const handleExcelExport = async () => {
    setLoading(true);
    setProgress(1); // Start progress at 1%

    let currentProgress = 1;

    // Progress simulation
    const interval = setInterval(() => {
      if (currentProgress < 95) {
        // Prevent going to 100% before API response
        currentProgress += 1;
        setProgress(currentProgress);
      }
    }, 50); // Update every 50ms

    const queryParamsR = {};

    if (employeeId) queryParamsR.epf_number = employeeId;
    if (branchId) queryParamsR.branchId = branchId;

    queryParamsR.startDate = startDate;
    queryParamsR.endDate = endDate;

    if (employeeName) queryParamsR.employeeName = employeeName;
    if (empType) queryParamsR.employee_type = empType;
    if (selectedDepartment) queryParamsR.departmentName = selectedDepartment;

    let responseReport = await axios.get("/adminAtendances-search-report", {
      params: queryParamsR,
    });
    setPdfData(responseReport.data.data);

    console.log("responseReport", responseReport);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Attendance Report");

    // Define cell styles with borders
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Define columns and add header
    worksheet.columns = [
      { header: "Name", key: "empName", width: 15 },
      { header: "Emp No", key: "empId", width: 15 },
      { header: "Branch", key: "branch", width: 15 },
      { header: "Date", key: "date", width: 15 },
      { header: "Clock In", key: "clockIn", width: 15 },
      { header: "Clock Out", key: "clockOut", width: 15 },
      { header: "Total Hours", key: "totalHours", width: 15 },
      { header: "Miss Punch", key: "missPunch", width: 15 },
    ];

    // Add data rows
    responseReport.data.data.forEach(
      ({
        employee,
        attendanceDate,
        earliestClockIn,
        latestClockOut,
        totalHours,
      }) => {
        let missPunch = earliestClockIn === latestClockOut ? "Yes" : ""; // Determine if it's a
        let row = worksheet.addRow({
          empName: employee.full_name,
          empId: employee.epf_number,
          branch: employee.branch,
          date: new Date(attendanceDate).toLocaleDateString(),
          clockIn: earliestClockIn ? earliestClockIn : "N/A",
          clockOut: latestClockOut ? latestClockOut : "N/A",
          totalHours: totalHours,
          missPunch: missPunch,
        });

        if (missPunch === "Yes") {
          row.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Yellow
            };
          });
        }
      }
    );

    // Apply border styles to all cells
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "attendance_report" + moment.now() + ".xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });

    clearInterval(interval); // Stop incrementing once response is received
    setProgress(100); // Set to 100% after API response
    setLoading(false);
  };
  // const currentMonth = currentDate.toLocaleString("default", { month: "long" });
  // const currentYear = currentDate.getFullYear();
  useEffect(() => {
    if (selectedRange[0] && selectedRange[1] && !hasFetched) {
      // getAllAdmintAttendancesWithoutPagination({
      //     setPdfData,
      //     setLoading: setLoading3,
      //     params: {page: pdfData.page, limit: pdfData.limit},
      //     search,
      //     startDate: selectedRange[0].format("YYYY-MM-DD"),
      //     endDate: selectedRange[1].format("YYYY-MM-DD"),
      //     workingHours: timeRangeForFetch ? timeRangeForFetch : "undefined"
      // });
      setHasFetched(true);
      // console.log(loading3)
    }
  }),
    [selectedRange[0], selectedRange[1]];

  // const getCalendarDays = () => {
  //   const year = currentDate.getFullYear();
  //   const month = currentDate.getMonth();
  //   const firstDayOfMonth = new Date(year, month, 1);
  //   const lastDayOfMonth = new Date(year, month + 1, 0);
  //   const daysInMonth = lastDayOfMonth.getDate();

  //   // Add padding for days from the previous month
  //   const startingDay = firstDayOfMonth.getDay();
  //   const calendarDays = [];
  //   for (let i = 0; i < startingDay; i++) {
  //     calendarDays.push("");
  //   }

  //   // Add days of the current month
  //   for (let i = 1; i <= daysInMonth; i++) {
  //     calendarDays.push(i);
  //   }

  //   return calendarDays;
  // };
  // const calendarDays = getCalendarDays();
  // const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

  const handleChangeDepartment = (value) => {
    setSelectedDepartment(value);
  };
  useEffect(() => {
    const fetchadmTypes = async () => {
      try {
        const department = await allDepartments({ search: "" });
        const dptOptions = department.map((item) => ({
          value: item.departmentName,
          label: item.departmentName,
        }));
        setDepartmentOptions(dptOptions);
      } catch (error) {
        console.error("Error in fetching Service Names", error);
      } finally {
        setLoading(false);
      }
    };
    fetchadmTypes();
  }, []);

  const handlePdfExport = async () => {
    const startdate = selectedRange[0].format("YYYY-MM-DD");
    const enddate = selectedRange[1].format("YYYY-MM-DD");
    const img = okilogo;

    // Filter out unwanted columns and add "Miss Punch" logic
    const filteredData = pdfData.map(
      ({
        employee,
        attendanceDate,
        earliestClockIn,
        latestClockOut,
        totalHours,
      }) => {
        const missPunch = earliestClockIn === latestClockOut ? "Yes" : ""; // Determine if it's a miss punch

        return {
          "Emp Name": `${employee.full_name}`,
          "Emp Id": employee.epf_number,
          Date: new Date(attendanceDate).toLocaleDateString(),
          "Clock In": earliestClockIn ? earliestClockIn : "N/A",
          "Clock Out": latestClockOut ? latestClockOut : "N/A",
          "Total Hours": totalHours,
          "Miss Punch": missPunch, // Add the "Miss Punch" column
        };
      }
    );

    const doc = new jsPDF();
    doc.setTextColor(0, 0, 0); // Black color
    doc.setFontSize(16);
    doc.text("OKI International", 15, 13);
    doc.setFontSize(14);
    doc.setTextColor(138, 132, 125);
    doc.text(`Attendance Report`, 15, 23);
    doc.text(`Date : ${startdate} - ${enddate}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);

    // Add "Miss Punch" to the table headers
    doc.autoTable({
      head: [
        [
          "Emp Name",
          "Emp Id",
          "Date",
          "Clock In",
          "Clock Out",
          "Total Hours",
          "Miss Punch",
        ],
      ],
      body: filteredData.map((data) => [
        data["Emp Name"],
        data["Emp Id"],
        data["Date"],
        data["Clock In"],
        data["Clock Out"],
        data["Total Hours"],
        data["Miss Punch"], // Include "Miss Punch" in the table body
      ]),
      startY: 35,
      theme: "striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });

    setTimeout(() => {
      doc.save("attendance_report.pdf");
    }, 1000);
  };

  // const today = new Date(); // Get today's date
  // const todayDay = today.getDate();
  // const todayMonth = today.getMonth();
  // const todayYear = today.getFullYear();
  ////Function to generate PDF end

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const id1 = userData?.data?.uid; //
  const [userRightssub, setUserRightssub] = useState([]);
  useEffect(() => {
    const fetchUserRightssub = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/userright/${id1}`);
        if (!response.ok) {
          throw new Error("Failed to fetch user rights");
        }
        const data = await response.json();
        console.log("Fetched User Sub Data:", data.data);
        setUserRightssub(data.data || []); // Ensure it's always an array
      } catch (error) {
        console.error("Error fetching data:", error);
        setUserRightssub([]); // Set to empty array in case of error
      }
    };

    fetchUserRightssub(); // Fetch the data on component mount
  }, [id]);
  const hasJobRightWithAdd = userRightssub.some(
    (right) => right.right === "attendance-employee" && right.adds === 1
  );
  const hasJobRightWithedit = userRightssub.some(
    (right) => right.right === "attendance-employee" && right.updates === 1
  );
  // const hasJobRightWithview = userRightssub.some(right => right.right === 'attendance-employee' && right.viewes === 1);
  const hasJobRightWithedel = userRightssub.some(
    (right) => right.right === "attendance-employee" && right.deletes === 1
  );
  const hasJobRightWithupload = userRightssub.some(
    (right) => right.right === "Shifts" && right.fupload === 1
  );

  useEffect(() => {
     const fetchData = async () => {
          try {
            setLoading(true);
            await getAllEmployeesMethod({
              setEmployeeData: (responseData) => {
                console.log('Employee API response:', responseData);
                const employeeData = responseData?.data || [];
                if (!Array.isArray(employeeData)) {
                  console.error('Employee data is not an array:', employeeData);
                  setEmployees([]);
                } else {
                  setEmployees(employeeData);
                }
              },
              setLoading,
              search: '',
              params: { page: 1, limit: 1000 },
            });
          } catch (error) {
            console.error('Error fetching data:', error);
            setEmployees([]);
          } finally {
            setLoading(false);
          }
        };
        fetchData();
  }, []);

  useEffect(() => {
    if (success) {
      handleCancel();
      setId(null);
      showSuccess("Successfully saved attendance!");
    }
    if (isDelete) {
      showSuccess("Successfully deleted attendance!");
    }
  }, [success, isDelete, shouldReloadData]);

  // Auto-trigger search when coming from dashboard
  useEffect(() => {
    if (dashboardState?.fromDashboard && startDate && endDate) {
      searchAttendance({ pagination });
    }
  }, [dashboardState?.fromDashboard]);

  useEffect(() => {
    const handler = setTimeout(async () => {}, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search, shouldReloadData]);

  const formatDateToDDMMYYYY = (inputDate) => {
    // If inputDate is already a Date, use it; otherwise, parse it
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);

    // Validate if the conversion was successful
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const handleOk = async () => {
    if (!time || !date || !employee) {
      showWarning("Please fill all fields");
      return;
    }
    const formatDate = formatDateToDDMMYYYY(date);
    //const formattedTimeRange = timeRange.map(time => dayjs(time).format('HH:mm:ss'));
    const submitData = {
      employee: employee,
      time: time,
      //workingHours,
      date: formatDate,
      reason,
      // shift: shift,
      // id
    };
    console.log(submitData);
    await createAttendanceMethod({
      data: submitData,
      setLoading,
      setSuccess,
    });
    handleReloadData();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    resetFields();
  };

  const resetFields = () => {
    // setTimeRange(null);
    setDate(null);
    setEmployee("");
    setWorkingHours(null);
    setTime(null);
    setReason("");
    //setShift("")
  };

  // const handleTimeRangeChange = (value) => {
  //     setTimeRange(value);
  //     if (value) {
  //         const [start, end] = value;
  //         const duration = dayjs(end).diff(dayjs(start), 'minute');
  //         const hours = Math.floor(duration / 60);
  //         const minutes = duration % 60;
  //         setWorkingHours(`${hours}h ${minutes}m`);
  //     } else {
  //         setWorkingHours(null);
  //     }
  // };

  const handleDateChange = (value) => {
    setDate(value ? dayjs(value).format("YYYY-MM-DD") : null);
  };

  const handleEmployeeChange = (value) => {
    setEmployee(value);
  };

  // const handleShiftChange = (value) => {
  //     setShift(value);
  // };

  const showSuccess = (str) => {
     showNotification('success', 'Good Job !', str);
  };

  const columns = [
    {
      title: "Emp No",
      dataIndex: ["employee", "epf_number"],
      key: "employee.epf_number",
    },
{
    title: "Full Name",
    key: "name",
    render: (text, record) => {
      const employee = record.employee || {};
      const name = employee.full_name
        ? employee.full_name
        : `${employee.first_name || ""} ${employee.last_name || ""}`.trim();
      console.log(`Rendering name for EPF ${employee.epf_number}:`, name); // Debug
      return name || "N/A";
    },
  },
    {
      title: "Branch",
      dataIndex: ["employee", "branch"],
      key: "employee.branch",
    },
    {
      title: "Date",
      dataIndex: "attendanceDate",
      key: "date",
      render: (text, record) =>
        `${new Date(record.attendanceDate).toLocaleDateString()}`,
    },
    {
      title: "Day",
      dataIndex: "dayOfWeek",
      key: "dayOfWeek",
    },
    {
      title: "Clock In",
      dataIndex: "earliestClockIn",
      key: "clockIn",
    },
    {
      title: "Clock Out",
      dataIndex: "latestClockOut",
      key: "clockOut",
    },
    {
      title: "Total Hours",
      dataIndex: "totalHours",
      key: "workingHours",
    },
//     {
//     title: "Location",
//     dataIndex: "town", 
//     key: "location",
// render: (text, record) => text || record.employee?.branch || "N/A", },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          {/* View Button - Always enabled */}
          <Link
            className="me-2 p-2"
            onClick={() => {
              setIsView(true);
              setIsEditModalOpen(true);
              setRecordEmpId(record.employee.epf_number);
              setRecordDate(record.attendanceDate);
              setId(record._id);
            }}
            title="View admin attendance"
          >
            <i data-feather="download" className="feather-eye"></i>
          </Link>

          {/* Edit Button - Combined with existing hasJobRight check */}
          {!hasJobRightWithedit && (
            <Link
              className={`me-2 p-2 ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Attendance",
                  "edit",
                  "Admin"
                )
                  ? ""
                  : "disabled"
              }`}
              onClick={() => {
                if (
                  !hasJobRightWithedit &&
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Attendance",
                    "edit",
                    "Admin"
                  )
                ) {
                  setRecordEmpId(record.employee.epf_number);
                  setRecordDate(record.attendanceDate);
                  setId(record._id);
                  setIsEditModalOpen(true);
                }
              }}
              title={
                !(
                  !hasJobRightWithedit &&
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Attendance",
                    "edit",
                    "Admin"
                  )
                )
                  ? "You don't have permission to edit admin attendance"
                  : "Edit admin attendance"
              }
            >
              <i data-feather="download" className="feather-edit"></i>
            </Link>
          )}

          {/* Delete Button - Combined with existing hasJobRight check */}
          {hasJobRightWithedel && (
            <Popconfirm
              title="Delete the Attendance"
              description="Are you sure to disable this Attendance?"
              onConfirm={() => {
                if (
                  hasJobRightWithedel &&
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Attendance",
                    "delete",
                    "Admin"
                  )
                ) {
                  deleteAdminAttendance({
                    id: record._id,
                    setIsDelete,
                  });
                }
              }}
              onCancel={() => console.log("Cancelled")}
              okText="Yes"
              cancelText="No"
              disabled={
                !(
                  hasJobRightWithedel &&
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Attendance",
                    "delete",
                    "Admin"
                  )
                )
              }
            >
              <Link
                className={`confirm-text p-2 ${
                  hasJobRightWithedel &&
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Attendance",
                    "delete",
                    "Admin"
                  )
                    ? ""
                    : "disabled"
                }`}
                title={
                  !(
                    hasJobRightWithedel &&
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Attendance",
                      "delete",
                      "Admin"
                    )
                  )
                    ? "You don't have permission to delete admin attendance"
                    : "Delete admin attendance"
                }
              >
                <i data-feather="x-circle" className="feather-x-circle"></i>
              </Link>
            </Popconfirm>
          )}
        </td>
      ),
    },
  ];
  //
  /*  const handleDatesChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };*/
  // const formatWorkHours = () => {
  //   if (hours !== null && minutes !== null) {
  //     return `${hours}h ${minutes}m`;
  //   }
  //   return null;
  // };

  // useEffect(() => {
  //   setTimeRangeForFetch(formatWorkHours());
  //   updateCurrentTime();

  //   const timer = setInterval(updateCurrentTime, 1000);
  //   return () => clearInterval(timer);
  // }, [minutes, hours]);

  const searchAttendance = async (params = {}) => {
    const queryParams = {
      page: params.pagination?.current || pagination.current,
      limit: params.pagination?.pageSize || pagination.pageSize,
      ...params.filters,
    };

    if (employeeId) queryParams.epf_number = employeeId;
    if (branchId) queryParams.branchId = branchId;

    queryParams.startDate = startDate;
    queryParams.endDate = endDate;

    if (employeeName) queryParams.employeeName = employeeName;
    if (empType) queryParams.employee_type = empType;
    if (selectedDepartment) queryParams.departmentName = selectedDepartment;

    let response = await axios.get("/adminAtendances-search", {
      params: queryParams,
    });
    setAttendanceData(response.data);
    // setAttendanceCount(response.data.totalResults);

    setPagination({
      ...pagination,
      current: params.pagination?.current || pagination.current,
      pageSize: params.pagination?.pageSize || pagination.pageSize,
      total: response.data.totalResults,
    });

    // Update the chart with the new data
    if (pdfData.data && pdfData.data.length > 0) {
      const currentWeekData = calculateCurrentWeekAttendance(pdfData.data);
      const monthlyData = calculateMonthlyAttendance(pdfData.data);

      setAttendanceWeeklyChart({
        ...attendanceWeeklyChart,
        series: [
          {
            name: "Current Time",
            data: currentWeekData,
          },
          {
            name: "This Month",
            data: monthlyData,
          },
        ],
      });
    }
  };

  useEffect(() => {
    searchAttendance({ pagination });
  }, []);

  // const handleTableChange = (newPagination) => {
  //   searchAttendance({ pagination: newPagination });
  // };

  const handleSearch = async () => {
    console.log("Search");
    setIsLoading(true);
    setPagination({ ...pagination, current: 1 });

    try {
      await searchAttendance({ pagination: { ...pagination, current: 1 } });
    } catch (error) {
      console.error("Error during search:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // Date selection handlers
  // const handleDateClick = (day) => {
  //   if (!day) return; // Skip empty cells

  //   const clickedDate = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     day
  //   );
  //   const formattedDate = formatDate(clickedDate);

  //   if (!startDate || (startDate && endDate)) {
  //     // Start new selection
  //     setStartDate(formattedDate);
  //     setEndDate(null);
  //     setSelectedDates([formattedDate]);
  //   } else {
  //     // Complete the selection
  //     if (new Date(formattedDate) < new Date(startDate)) {
  //       // If clicked date is before start date, swap them
  //       setEndDate(startDate);
  //       setStartDate(formattedDate);
  //     } else {
  //       setEndDate(formattedDate);
  //     }

  //     // Update selected dates range for highlighting
  //     updateSelectedDatesRange(startDate, formattedDate);
  //   }
  // };

  // Update the range of selected dates for visual feedback
  // const updateSelectedDatesRange = (start, end) => {
  //   const startDateObj = new Date(start);
  //   const endDateObj = new Date(end);
  //   const dateRange = [];

  //   const currentDate = new Date(startDateObj);
  //   while (currentDate <= endDateObj) {
  //     dateRange.push(formatDate(currentDate));
  //     currentDate.setDate(currentDate.getDate() + 1);
  //   }

  //   setSelectedDates(dateRange);
  // };

  // Format date to YYYY-MM-DD
  // const formatDate = (date) => {
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}-${month}-${day}`;
  // };

  // Check if a date is in the selected range
  // const isDateSelected = (day) => {
  //   if (!day) return false;
  //   const dateStr = formatDate(
  //     new Date(currentDate.getFullYear(), currentDate.getMonth(), day)
  //   );
  //   return selectedDates.includes(dateStr);
  // };

  // // Check if a date is the start or end of the selection
  // const isDateEndpoint = (day) => {
  //   if (!day) return false;
  //   const dateStr = formatDate(
  //     new Date(currentDate.getFullYear(), currentDate.getMonth(), day)
  //   );
  //   return dateStr === startDate || dateStr === endDate;
  // };

  const calculateCurrentWeekAttendance = (data) => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(
      today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)
    );

    const weekDayTotals = Array(7).fill(0);
    const weekDayCounts = Array(7).fill(0);

    data.forEach(({ attendanceDate, totalHours }) => {
      const date = new Date(attendanceDate);
      if (date >= startOfWeek && date <= today) {
        const day = date.getDay();
        const dayIndex = day === 0 ? 6 : day - 1;

        if (totalHours && !isNaN(parseFloat(totalHours))) {
          weekDayTotals[dayIndex] += parseFloat(totalHours);
          weekDayCounts[dayIndex]++;
        }
      }
    });

    return weekDayTotals.map((total, index) =>
      weekDayCounts[index] > 0
        ? parseFloat((total / weekDayCounts[index]).toFixed(1))
        : 0
    );
  };
  const selectedDates = (e) => {
    if (!e || e.length === 0) {
      // Handle clearing the date picker
      setStartDate(null);
      setEndDate(null);
      return;
    }
    console.log("Selected Dates", e[0], dayjs(e[1]).format("YYYY-MM-DD"));
    console.log("Selected Dates", e);
    setStartDate(dayjs(e[0]).format("YYYY-MM-DD"));
    setEndDate(dayjs(e[1]).format("YYYY-MM-DD"));
  };
  const calculateMonthlyAttendance = (data) => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const weekDayTotals = Array(7).fill(0);
    const weekDayCounts = Array(7).fill(0);

    data.forEach(({ attendanceDate, totalHours }) => {
      const date = new Date(attendanceDate);
      if (date >= startOfMonth && date <= today) {
        const day = date.getDay();
        const dayIndex = day === 0 ? 6 : day - 1;

        if (totalHours && !isNaN(parseFloat(totalHours))) {
          weekDayTotals[dayIndex] += parseFloat(totalHours);
          weekDayCounts[dayIndex]++;
        }
      }
    });

    return weekDayTotals.map((total, index) =>
      weekDayCounts[index] > 0
        ? parseFloat((total / weekDayCounts[index]).toFixed(1))
        : 0
    );
  };

  const [attendanceWeeklyChart, setAttendanceWeeklyChart] = useState({
    series: [
      {
        name: "Current Time",
        data: [0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "This Month",
        data: [0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: {
        height: 200,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      colors: ["#FF9800", "#2196F3"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      },
      yaxis: {
        show: false,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      legend: {
        show: true,
        position: "top",
      },
      grid: {
        show: false,
      },
    },
  });

  return (
    <div className="page-wrapper-lt">   {contextHolder}
      <div className="content-adm">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-att-container ">
              <h1>
                <Calendar size={24} style={{ marginRight: "20px" }} />
                Attendance
              </h1>
              <p>
                Here, you can efficiently manage all employee details with ease
                and precision.
              </p>
              <div className="page-title"></div>
            </div>
          </div>
          <div className="wordset">
            <Progress percent={progress} size="small" />
            <ul>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="pdf"
                  //</li> onClick={generatePDF}
                  onClick={handlePdfExport}
                >
                  <img src="assets/img/icons/pdf.svg" alt="pdf" />
                </a>
              </li>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="excel"
                  onClick={handleExcelExport}
                >
                  <img src="assets/img/icons/excel.svg" alt="excel" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="print"
                >
                  <img src="assets/img/icons/printer.svg" alt="print" />
                </a>
              </li>
              <div className="page-btn">
                {!hasJobRightWithupload && (
                  <a
                    className="btn btn-added-grid"
                    onClick={() => setIsBulkUploadModalOpen(true)}
                  >
                    <Upload className="me-2" />
                    Bulk
                  </a>
                )}
              </div>
              <div className="page-btn">
                {!hasJobRightWithAdd && (
                  <a
                    className="btn btn-added"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <PlusCircle className="me-2" />
                    Attendance
                  </a>
                )}
              </div>
            </ul>
          </div>
        </div>

        <div className="row row1">
          <div className="col-3 col-d"               style={{ display: "none" }}
          >
            <div
              className="card table-list-card-lt"
            >
              <div
                className="container mt-3 "
                style={{
                  maxWidth: "100%",
                  marginLeft: "20px",
                  marginRight: "40px",
                }}
              >
                <h3 className="lt_chart_title">Average Attendance</h3>

                <ReactApexChart
                  options={attendanceWeeklyChart.options}
                  series={attendanceWeeklyChart.series}
                  type="line"
                  height={200}
                />
              </div>
            </div>
          </div>

          {/* <div className="stat-card">
                <div className="icon">
                  <Clock size={24} />
                </div>
                <div className="time">
                  <span className="hours">{currentTime}</span>
                </div>
                <p className="label">Current Time</p>
              </div>
              <div className="stat-card">
                <div className="icon">
                  <Users size={24} />
                </div>
                <div className="time">
                  <span className="hours">{attendanceCount}</span>
                </div>
                <p className="label">Head Count</p>
              </div> */}

          {/* <div className="col-9 col-dd"> */}
            <div className="card table-list-card-grid">
              <div
                className="card-body"
                style={{ maxWidth: "100%", marginRight: "20px" }}
              >
                <div
                  className="container mt-3 "
                  style={{
                    maxWidth: "100%",
                    marginLeft: "20px",
                    marginRight: "40px",
                  }}
                >
                  <div className="row gx-3 gy-3">
                    <div className="col-2">
                      <label className="form-label">EPF No</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => setEmployeeId(e.target.value)}
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => setEmployeeName(e.target.value)}
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Branch</label>
                      <select
                        className="form-select"
                        id="autoSizingSelect"
                        value={branchId}
                        onChange={(e) => setBranchId(e.target.value)}
                        style={{ width: "100%", height: "40px" }}
                      >
                        <option value="">Choose...</option>
                        <option value="wattala">Wattala</option>
                        <option value="negombo">Negombo</option>
                        <option value="kaduwela">Kaduwela</option>
                        <option value="kiribathgoda">Kiribathgoda</option>
                        <option value="kandana">Kandana</option>
                        <option value="delgoda">Delgoda</option>
                        <option value="okids">OKIDS-Wattala</option>
                        <option value="okit">OKIT-Wattala</option>
                        <option value="lsu">Wattala LSU</option>
                        <option value="cityschool">City School - Negombo</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="date-range" className="form-label">
                        Select Date Range
                      </label>
                      <RangePicker
                        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
                        onChange={selectedDates}
                        placeholderText="Select a date range"
                        style={{
                          width: "100%",
                          height: "20px",
                          padding: "20px",
                        }}
                      />
                    </div>

                    <div className="col-12">
                      <div className="d-flex align-items-center">
                        <div className="col-lg-2">
                          <div className="input-blocks">
                            <label>Employee Type</label>
                            <Select
                              value={empType}
                              onChange={setEmpType}
                              className="select"
                              options={employeeTypes}
                              placeholder="Select Employee Type"
                              allowClear
                              style={{ width: "100%", height: "40px" }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 " style={{ marginLeft: 20 }}>
                          <div className="input-blocks">
                            <label>Department</label>
                            <Select
                              value={selectedDepartment}
                              options={departmentOptions}
                              className="select"
                              placeholder="Select Department"
                              onChange={handleChangeDepartment}
                              allowClear
                              style={{ width: "100%", height: "40px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={handleSearch}
                    disabled={isLoading}
                    type="button"
                    className="btn btn-primary"
                  >
                    {isLoading ? "Searching..." : "Search"}
                  </button>
                  {isLoading && (
                    <div>
                      <div className="spinner"></div>{" "}
                    </div>
                  )}
                </div>
              </div>
            {/* </div> */}
          </div>
          <div className="card table-list-card-grid">
            {/* <div
                className="card-body"
                style={{
                  maxWidth: "100%",
                  marginRight: "20px",
                  backgroundColor: "transparent",
                  borderRadius: "8px",
                }}
              > */}
            <div className="table-responsive">
              <Table
                id="table-to-pdf"
                columns={columns}
                dataSource={attendanceData.data}
                rowKey={(record) => record._id}
                loading={loading2}
                rowClassName={() => "custom-row"}
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`,
                  onChange: (page, pageSize) => {
                    searchAttendance({
                      pagination: {
                        ...pagination,
                        current: page,
                        pageSize: pageSize,
                      },
                    });
                    // Fetch data based on page and pageSize
                  },
                }}
              />
              {/* </div> */}
            </div>
          </div>
        </div>

        <Modal
          zIndex={200000}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          maskClosable={false}
          closable={false}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{isEdit ? "Edit" : "Add"} Attendance</h4>
                    <p className="mb-0">
                      Fill in the required fields to{" "}
                      {isEdit ? "edit" : "create"} an Attendance
                    </p>
                  </div>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Time</label>
                    <TimePicker
                      size="large"
                      value={time ? moment(time, "HH:mm") : null}
                      onChange={handleTimeChange}
                      format="HH:mm"
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Date</label>
                    <DatePicker
                      size="large"
                      onChange={handleDateChange}
                      format="YYYY-MM-DD"
                      value={date ? dayjs(date, "YYYY-MM-DD") : null}
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Select Employee</label>
                    <Select
                      size="large"
                      showSearch
                      placeholder="Select an employee"
                      onChange={handleEmployeeChange}
                      value={employee || undefined}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      allowClear
                      style={{ width: "100%" }}
                    >
                      {Array.isArray(employees) && employees.length > 0 ? (
      employees.map((emp) => (
        <Select.Option key={emp._id} value={emp._id}>
          {emp.epf_number
            ? `${emp.epf_number} - ${emp.full_name}`
            : `N/A - ${emp.full_name}`}
        </Select.Option>
      ))
    ) : (
      <Select.Option disabled>No employees available</Select.Option>
    )}
                    </Select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Reason</label>
                    <Input.TextArea
                      size="large"
                      placeholder="Enter the reason"
                      style={{ width: "100%" }}
                      value={reason} // Bind state to TextArea
                      onChange={handleReasonChange} // Handle input change
                    />
                  </div>

                  {workingHours && (
                    <div className="mb-3">
                      <Badge
                        color="geekblue"
                        text={`Working Hours: ${workingHours}`}
                      />
                    </div>
                  )}
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-cancel"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Close
                    </button>
                    <div className="">
                      <button
                        type="button"
                        className="btn btn-reset me-2"
                        onClick={resetFields}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn btn-submit ml-0"
                        onClick={handleOk}
                        disabled={loading}
                      >
                        {loading ? <Spin size="small" /> : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          zIndex={1050}
          open={isEditModalOpen}
          onOk={() => setIsEditModalOpen(false)}
          onCancel={() => setIsEditModalOpen(false)}
          footer={null}
          maskClosable={false}
          closable={false}
          width={600}
        >
          <EditAttendanceAdminModal
            handleCancel={() => {
              setIsEditModalOpen(false);
              setIsView(false);
            }}
            employeeId={recordEmpId}
            date={recordDate}
            isView={isView}
            onChange={searchAttendance}
          />
        </Modal>

        <Modal
          title="Change Page Size"
          open={pageSizeModalVisible}
          onOk={handlePageSizeChange}
          onCancel={() => setPageSizeModalVisible(false)}
          footer={[
            <button
              key="cancel"
              className="btn btn-cancel"
              onClick={() => setPageSizeModalVisible(false)}
            >
              Cancel
            </button>,
            <button
              key="submit"
              className="btn btn-submit"
              onClick={handlePageSizeChange}
            >
              Apply
            </button>,
          ]}
        >
          <div className="form-group">
            <label>Items per page:</label>
            <Select
              style={{ width: "100%" }}
              value={tempPageSize}
              onChange={(value) => setTempPageSize(value)}
            >
              {pageSizeOptions.map((size) => (
                <Select.Option key={size} value={size}>
                  {size}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Modal>
        <BulkUploadModal
          isVisible={isBulkUploadModalOpen}
          handleCancel={() => setIsBulkUploadModalOpen(false)}
          onUploadData={handleReloadData}
          setLoading={setLoading}
          setProgress={setProgress}
        />
      </div>
    </div>
  );
};

export default Designation;
